var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.timeLeft && _vm.timeLeft < _vm.twoMinutesMiliseconds)?_c('div',{staticClass:"time-bar-wrapper position-relative"},[_c('div',{staticClass:"time-bar rounded bg-red",style:(_vm.widthBar)})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }